import { Chip, LinearProgress, List, ListItem, Stack, Tooltip, IconButton } from '@mui/material'
import { Link } from 'react-router-dom'
import { yellow } from '@mui/material/colors'
import React, { useEffect, useState } from 'react'
import useAuth from '../../../hooks/useAuth'
import { Check, Science } from '@mui/icons-material'
import SourceApi from '../../../api/SourceApi'
import {
    getValidSourceTypes,
    isSingularIssueSourceType,
    isSingularWarrantSourceType,
} from '../../../utils/issues/sourceTypes'

const sourceApi = new SourceApi()

export const CompanyEventRow = ({
    event,
    eventType,
    selectedRows,
    associatedPRs,
    setAssociatedPRs,
    sourceType,
    setSourceType,
    selectedPR,
    onCreateSource,
    onArchivePR,
    children,
}) => {
    const { isAuthenticated } = useAuth()
    const [existingSources, setExistingSources] = useState(null)

    useEffect(() => {
        if (!isAuthenticated) return
        const fetchData = async () => {
            if (eventType === 'issue') {
                const result = await sourceApi.findByIssueId(event.id)
                setExistingSources(result)
            }
            if (eventType === 'warrant') {
                const result = await sourceApi.findByWarrantId(event.id)

                console.log(`Existing sources for warrant ${event.name}`, result)
                setExistingSources(result)
            }
            if (eventType === 'convertible') {
                const result = await sourceApi.findByConvertibleId(event.id)

                console.log(`Existing sources for convertible ${event.name}`, result)
                setExistingSources(result)
            }
        }
        fetchData()
    }, [isAuthenticated, event, eventType])

    const selectedRow = selectedRows.some((e) => e.id === event.id)
    const selectColor = yellow[300]
    let associatedList = null

    if ((associatedPRs && associatedPRs[event.id]?.length > 0) || existingSources?.length > 0) {
        const prListItem = (source) => (
            <ListItem key={source.id}>
                <Link to={source.sourceUrl} target='_blank'>
                    <Chip size='small' color='primary' variant='outlined' label={source.sourceType} />{' '}
                    {source.title || source.sourceUrl}
                </Link>
            </ListItem>
        )
        associatedList = (
            <List>
                {associatedPRs[event.id]?.map((source) => prListItem(source))}
                {!existingSources && <LinearProgress />}
                {existingSources?.map((source) => prListItem(source))}
            </List>
        )
    }
    const onAssociate = async () => {
        if (!onCreateSource) {
            throw new Error('onCreateSource not implemented')
        }
        if (!sourceType) {
            alert('Välj källtyp först')
            return
        }
        if (!selectedPR) {
            console.log('ERROR: No selected PR')
            throw new Error('No selected PR')
        }
        // const associatedPR = { pr, sourceType }
        // check valid source type for issues and warrants
        if (getValidSourceTypes(eventType === 'issue' ? event.type : eventType).includes(sourceType)) {
            const isSingularType =
                eventType === 'issue' ? isSingularIssueSourceType(sourceType) : isSingularWarrantSourceType(sourceType)
            if (isSingularType && existingSources?.some((s) => s.sourceType === sourceType)) {
                alert(
                    `Källtypen ${sourceType} är redan kopplad till denna ${
                        eventType === 'issue' ? 'emission' : eventType === 'warrant' ? 'option' : 'konvertibel'
                    }`,
                )
                return
            }
            // if we reach this point, the source type is valid
        } else {
            alert(`Källtypen ${sourceType} är inte giltig för emissionstypen ${event.type}`)
            return
        }

        const source = await onCreateSource(event, selectedPR, sourceType)

        if (!source) {
            console.error('Failed to create source')
            return
        } else {
            console.log('Created source', source)
        }
        if (!associatedPRs[event.id]) {
            associatedPRs[event.id] = []
        }

        associatedPRs[event.id].push(source)
        setAssociatedPRs({ ...associatedPRs })

        if (setSourceType) setSourceType(null)
        if (onArchivePR) onArchivePR(selectedPR)
    }

    const isEventCompleted =
        eventType !== 'convertible' ? Boolean(event?.statusStage === 10 && event?.statusComplete) : !!event.completed

    return (
        <tr>
            <td>
                <Stack
                    spacing={2}
                    key={event.id}
                    sx={{ bgcolor: selectedRow ? selectColor : null, mb: associatedList ? 0 : 6 }}
                >
                    <Stack direction='row' spacing={2} alignItems={'center'}>
                        <Tooltip
                            title={`Koppla PM till ${eventType === 'issue' ? 'emission' : eventType === 'warrant' ? 'option' : 'konvertibel'}`}
                        >
                            <IconButton
                                sx={{
                                    width: 30, // Adjust the width for your desired size
                                    height: 30, // Adjust the height for your desired size
                                    borderRadius: '50%', // Makes the button round
                                    backgroundColor: isEventCompleted ? 'success.main' : 'primary.main', // Optional: Set a background color for better visibility
                                    border: '2px solid', // Adds a border
                                    borderColor: isEventCompleted ? 'success.main' : 'primary.main', // Set border color with main variant
                                    color: 'white', // Set icon color for better contrast
                                    '&:hover': {
                                        backgroundColor: isEventCompleted ? 'success.dark' : 'primary.dark', // Darker color on hover
                                        borderColor: isEventCompleted ? 'success.dark' : 'primary.dark', // Darker border color on hover
                                    },
                                }}
                                onClick={() => onAssociate()}
                            >
                                {isEventCompleted && <Check sx={{ fontSize: 22 }} />}
                                {!isEventCompleted && <Science sx={{ fontSize: 22 }} />}
                            </IconButton>
                        </Tooltip>
                        <>{children}</>
                    </Stack>
                    {associatedList}
                </Stack>
            </td>
        </tr>
    )
}
